import { render, staticRenderFns } from "./ModalDireccion.vue?vue&type=template&id=517adc34"
import script from "./ModalDireccion.vue?vue&type=script&lang=js"
export * from "./ModalDireccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports